import styled from 'styled-components';

export const IconContainer = styled.div`
  text-align: center;
`;

export const IconWrapper = styled.img`
  width: ${props => props.width};
`;
